const GeradorDeLinksSection = () => {
  return (
    <section className="py-24 px-6 sm:px-12 text-gray-900">
      <div className="max-w-7xl mx-auto grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
        {/* Texto */}
        <div className="text-center lg:text-left">
          <h3 className="text-sm font-semibold uppercase tracking-wide text-gray-800/80">
            Atendimento com mais agilidade
          </h3>
          <h2 className="mt-4 text-4xl sm:text-5xl font-bold tracking-tight leading-tight text-gray-900">
            Gere links filtrados e envie exatamente o que o cliente procura
          </h2>
          <p className="mt-6 text-lg leading-8 text-gray-800/90 max-w-xl mx-auto lg:mx-0">
            Com a Vintree, você pode criar links personalizados com filtros por
            categorias, termos ou produtos específicos. Ideal para responder
            clientes com rapidez no WhatsApp e levar direto ao que eles querem
            ver — sem enrolação, sem perder tempo.
          </p>
        </div>

        {/* Mockup do Gerador de Links */}
        <div className="relative w-full max-w-sm mx-auto aspect-[9/16]">
          <img
            src="/mockups/screenshot gerador de links.png"
            alt="Gerador de Links Vintree"
            className="absolute top-0 left-0 w-full h-full object-cover"
          />
        </div>
      </div>
    </section>
  );
};

export default GeradorDeLinksSection;
